"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var manager_1 = require("./manager");

exports.I18nManager = manager_1.I18nManager;

var context_1 = require("./context");

exports.I18nContext = context_1.I18nContext;

var i18n_1 = require("./i18n");

exports.I18n = i18n_1.I18n;

var hooks_1 = require("./hooks");

exports.useI18n = hooks_1.useI18n;

var decorator_1 = require("./decorator");

exports.withI18n = decorator_1.withI18n;

var utilities_1 = require("./utilities");

exports.translate = utilities_1.translate;

var types_1 = require("./types");

exports.LanguageDirection = types_1.LanguageDirection;
exports.CurrencyCode = types_1.CurrencyCode;

var constants_1 = require("./constants");

exports.currencyDecimalPlaces = constants_1.currencyDecimalPlaces;
exports.DEFAULT_DECIMAL_PLACES = constants_1.DEFAULT_DECIMAL_PLACES;
exports.DateStyle = constants_1.DateStyle;
exports.Weekday = constants_1.Weekday;